export default "__VITE_ASSET___vRWK3JH__"